import { render, staticRenderFns } from "./oldManFileFourth.vue?vue&type=template&id=64cb5534&scoped=true&"
import script from "./oldManFileFourth.vue?vue&type=script&lang=js&"
export * from "./oldManFileFourth.vue?vue&type=script&lang=js&"
import style0 from "./oldManFileFourth.vue?vue&type=style&index=0&id=64cb5534&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64cb5534",
  null
  
)

export default component.exports